/* @flow */
import React from 'react';
import invariant from 'invariant';
import { Container } from 'flux/utils';

import LoadingIndicator from 'components/LoadingIndicator.jsx';
import GroupActions from 'groups/actions/GroupActions';
import GroupMembersTabList from 'groups/components/GroupMembersTabList.jsx';
import GroupStore from 'groups/stores/GroupStore';
import GroupMembershipStore from 'stores/GroupMembershipStore';

import styles from './styles/GroupMembersTabListView.css';

class GroupMembersTabListView extends React.Component {
  static propTypes = {
    params: React.PropTypes.object.isRequired,
  };

  static getStores() {
    return [GroupStore, GroupMembershipStore];
  }

  static calculateState(prevState, props) {
    const group = GroupStore.getGroupForCode(props.params.groupCode);

    if (!group) {
      return {
        loading: true,
      };
    }
    const uuid = group.getUuid() || 'r';

    const members = GroupMembershipStore.getGroupMembershipsForGroup(group.id);
    const loading = !GroupMembershipStore.isLoadedForGroup(uuid);

    return {
      group,
      loading,
      members,
    };
  }

  state = {};

  componentWillMount() {
    const group = GroupStore.getGroupForCode(this.props.params.groupCode);
    if (this.state.loading) {
      GroupActions.loadGroupMemberships(group);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.params.groupCode !== this.props.params.groupCode) {
      const group = GroupStore.getGroupForCode(nextProps.params.groupCode);
      invariant(group, 'group unavailable in GroupMembersTabListView');
      if (!GroupMembershipStore.isLoadedForGroup(group.getUuid())) {
        GroupActions.loadGroupMemberships(group);
      }
    }
  }

  render() {
    const { loading, group, members } = this.state;
    return loading ?
      <div className={styles.loading}><LoadingIndicator size="large" /></div> :
      <GroupMembersTabList group={group} members={members} />;
  }
}

// Need to access props.params for route groupCode information
export default Container.create(GroupMembersTabListView, { withProps: true });



// WEBPACK FOOTER //
// ./src/groups/components/GroupMembersTabListView.jsx